export default __webpack_public_path__ + "static/media/Other.d34fddaf.svg";